import {useParams} from 'react-router-dom';

import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {RiskAssessmentForm} from 'src/app/risk-assessment-code/RiskAssessmentCodeForm/RiskAssessmentForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const EditRiskAssessmentCodePage = () => {
  const {riskAssessmentId} = useParams();

  return (
    <ContentWrapper>
      <RiskAssessmentForm id={+riskAssessmentId!} mode="edit" view="content" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.RiskAssessmentEdit(':riskAssessmentId'),
  element: <EditRiskAssessmentCodePage />,
  module: ModuleEnum.RiskAssessmentCodes,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});

export default EditRiskAssessmentCodePage;
